import * as deepExtend from 'deep-extend';
import { debounce } from 'debounce';
import { ObjectStorage } from 'shared/api/object-storage';
import { isMobileApp } from 'webui/utils/version';
let debounced_setter = {};
const debounced_save = debounce((api) => {
    if (isMobileApp()) {
        const current = ObjectStorage.get(window.localStorage, 'ui_settings') ?? {};
        ObjectStorage.set(window.localStorage, 'ui_settings', deepExtend(current, debounced_setter));
    }
    else {
        api.set_ui_settings(debounced_setter).then();
    }
    debounced_setter = {};
}, 500);
export const set_ui_settings = (setter, readonly) => (dispatch, getState, { api }) => {
    dispatch({ type: 'SET_UI_SETTINGS', setter });
    const state = getState();
    if (!readonly && !state.account.is_demo && !state.account.is_guest) {
        deepExtend(debounced_setter, setter);
        debounced_save(api);
    }
};
export const open_left_menu = () => {
    return {
        type: 'SET_UI_SETTINGS',
        setter: { leftpanel: { collapsed: false } },
    };
};
export const close_left_menu = () => {
    return {
        type: 'SET_UI_SETTINGS',
        setter: { leftpanel: { collapsed: true } },
    };
};
export const openHeatingTab = () => {
    return set_ui_settings({ selected_tab_key: 'heat_tab' });
};
export const select_ui_settings = (state) => state.ui_settings;
export const is_sorting_mode = (state, device_id) => state.ui_settings.sorting_mode === device_id;
export const is_dashboard_sorting_mode = (state) => state.ui_settings.sorting_mode === 'dashboard';
export const is_grouping_mode = (state) => state.ui_settings.grouping_mode ?? false;
export function get_initial_ui_settings(PRELOAD) {
    if (isMobileApp()) {
        return ObjectStorage.get(window.localStorage, 'ui_settings') ?? {};
    }
    else {
        return PRELOAD.ui_settings;
    }
}
export function getIdleModeEnabled(state) {
    return select_ui_settings(state).idle_mode_enabled ?? true;
}
export const set_device_service_mode = (device_id, service_mode) => (dispatch) => {
    const devices_service_mode = ObjectStorage.get(localStorage, 'devices_service_mode');
    ObjectStorage.set(localStorage, 'devices_service_mode', {
        ...devices_service_mode,
        [device_id]: service_mode,
    });
    return dispatch(set_ui_settings({ devices_service_mode: { [device_id]: service_mode } }));
};
export const create_reducer = (PRELOAD) => (state = get_initial_ui_settings(PRELOAD), action) => {
    switch (action.type) {
        case 'SET_UI_SETTINGS':
            return deepExtend({}, state, action.setter);
        default:
            return state;
    }
};
